<template>
  <div
    class="content-box testimonials text-center"
    :class="[
      hasCenteredClass,
      hasDenseClass,
      hasNoMarginClass,
      data.customClass
    ]"
  >
    <h2 v-if="hasTitle">{{ title }}</h2>
    <p>
      {{ localize(this.data.text) }}
    </p>

    <div class="carousel-wrapper">
      <testimonial-item
        :data="item"
        v-for="(item, index) in data.content"
        :key="`testimonial_item_${index}`"
        class="carousel-cell"
      ></testimonial-item>
    </div>
  </div>
</template>

<script>
import testimonialItem from './testimonial-item.vue';
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    hasCenteredClass() {
      if (this.data.isCentered) {
        return 'text-center';
      } else {
        return '';
      }
    },

    hasCenteredHeadlineClass() {
      if (this.data.isHeadlineCentered) {
        return 'text-center';
      } else {
        return '';
      }
    },

    hasDenseClass() {
      if (this.data.isDense) {
        return 'content-box__dense';
      } else {
        return '';
      }
    },

    hasNoMarginClass() {
      if (this.data.hasNoMargin) {
        return 'content-box__no-margin';
      } else {
        return '';
      }
    },

    hasTitle() {
      return (
        this.data.title &&
        Object.keys(this.data.title).length > 0 &&
        this.localize(this.data.title) !== ''
      );
    },

    title() {
      if (Array.isArray(this.data.title)) {
        return this.localize(this.data.title);
      } else {
        return this.localize(this.data.title[0]);
      }
    }
  },

  mounted() {
    const elem = document.querySelector('.carousel-wrapper');

    // eslint-disable-next-line
    const flkty = new Flickity(elem, {
      wrapAround: false,
      fullscreen: false,
      imagesLoaded: true,
      adaptiveHeight: true,
      cellAlign: 'left'
    });
  },

  components: {
    testimonialItem
  }
};
</script>

<style lang="scss" scoped>
.carousel-cell.testimonial-item {
  width: 100%;
  margin-top: 60px;
  margin-right: 20px;
  height: auto;
}

@media only screen and (min-width: 960px) {
  .carousel-cell.testimonial-item {
    width: 50%;
    height: 500px;
  }
}
</style>
